function ImageShow({image, title,des=null}) {
  return (
    <div className="image-container">
      <img
        src={image}
        alt="Banner"
        className="image-Show"
      />
      <h1 className='title'>{title}</h1>
      <p>{des}</p>
    </div>
  );
}

export default ImageShow;